export const INTERPRETER_SERVICE_ENDPOINT = window.env.VUE_APP_APP_SERVICE_DOMAIN;

/***** Resource paths *****/
// module
export const INTERPRETER_MODULE_RESOURCE_PATH = '/module';
export const INTERPRETER_MODULE_RUN_RESOURCE_PATH = '/run';
export const INTERPRETER_MODULE_PARSE_RESOURCE_PATH = '/parse';
export const INTERPRETER_MODULE_CHECK_RESOURCE_PATH = '/check';
export const FILE_UPLOAD_RESOURCE_PATH = '/upload';
